<template>
  <div>
    <v-form
      ref="form"
      v-model="valid"
      id="login-form"
      @submit.prevent="onSubmit"
    >
      <v-layout column wrap mt-3 mb-3>
        <v-layout wrap>
          <v-flex xs12>
            <v-text-field
              rounded
              v-model="email"
              :value="email"
              outlined
              solo
              :rules="emailRules"
              id="email-login-field"
              type="search"
              label="דואר אלקטרוני"
              prepend-inner-icon="mdi-email-outline"
              required
              clearable
              autocomplete="on"
              dir="auto"
              dense
            />
          </v-flex>
        </v-layout>

        <v-layout wrap>
          <v-flex xs12>
            <v-text-field
              v-model="password"
              :value="password"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="show1 = !show1"
              :type="show1 ? 'text' : 'password'"
              solo
              :rules="passwordRules"
              id="password-login-field"
              outlined
              rounded
              label="סיסמא"
              prepend-inner-icon="mdi-lock"
              required
              clearable
              dense
              autocomplete="on"
            />
          </v-flex>
        </v-layout>
        <div class="text-left password-recover pointer-underline">
          <v-btn color="black " class="pa-0" text dark @click="passwordReset">
            שכחתי סיסמה
          </v-btn>
        </div>
        <v-flex xs12>
          <v-checkbox
            class="mt-0 pt-0"
            v-model="rememberMe"
            :label="'זכור אותי'"
          ></v-checkbox>
        </v-flex>

        <v-row justify-content="center">
          <v-col cols="12" class="text-center py-0">
            <div v-if="loginError" class="login-error">
              <span class="red--text display-14">
                {{ loginErrorMsg }}
              </span>
            </div>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn
              id="submit-login-btn"
              type="submit"
              :loading="loginBusy"
              :disabled="!valid"
              class="orange_btn_large"
            >
              כניסה
            </v-btn>
          </v-col>
        </v-row>
      </v-layout>
    </v-form>
    <FormDialog />
  </div>
</template>


<script>
import { mapState } from 'vuex';
import FormDialog from '@/components/Dialogs/FormDialog';
import CurrentUser from '@/components/mixins/CurrentUser';
import recaptchaV3 from '@/components/mixins/recaptchaV3';

import { emailRules, passwordRules } from '@/lib/rules.js';

// import { load } from 'recaptcha-v3';

export default {
  mixins: [CurrentUser, recaptchaV3],
  name: 'FormLogin',
  components: {
    FormDialog,
  },

  data() {
    return {
      auth: this.isLogged,
      loginBusy: false,
      process: false,
      valid: false,

      loginError: false,
      loginErrorMsg: 'שם משתמש או סיסמה שגויים.נסה/י שוב',
      show1: null,

      terms: false,
      rememberMe: true,
      email: '',
      password: '',
      emailRules,
      passwordRules,
    };
  },
  props: {
    emitToCVPopup: {
      type: Boolean,
      required: false,
      default: false,
    },
    /** props if should active OTP on page*/
    activateOtpOnPage: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  created() {
    this.emailNew = '';
  },
  mounted() {
    /**
     * This bus listen to smart agent step 1 , if the user exists moving email to login
     */
    this.$nuxt.$on('hasEmail', this.setEmail);
  },

  computed: {
    ...mapState({
      // busy: (state) => state.auth.busy,
    }),

    // loginBusy() {
    //   return this.busy;
    // },
  },
  methods: {
    setEmail(_email) {
      this.email = _email;
    },
    /**
     * open reset form on @FormDialog component.
     * emit the email to dialog form field.
     */
    passwordReset() {
      this.$bus.$emit('passwordReset', this.email);
    },

    async onSubmit() {
      this.loginBusy = true;
      if (this.$refs.form.validate()) {
        try {
          const recaptcha = await this.recaptchaCheck('login');

          if (!recaptcha) {
            throw new Error('Recaptcha failed');
          }
          const res = await this.$store.dispatch('login', {
            Email: this.email,
            Password: this.password,
            RememberMe: this.rememberMe,
          });

          if (this.activateOtpOnPage) {
            this.$nuxt.$emit('openOTP', 'default');
          }

          if (res) {
            let returnUrl = this.$route.query.ReturnUrl;
            if (this.emitToCVPopup) this.$emit('showCVForm');
            else if (returnUrl) {
              let url = decodeURIComponent(
                window.location.search.split('?ReturnUrl=')[1]
              );
              this.$router.push(url);
            } else {
              this.$router.push('/');
            }
          } else {
            throw 'שגיאת התחברות';
          }
        } catch (err) {
          this.loginError = true;
          this.loginBusy = false;
          console.log(err);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-btn__content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-decoration: none;
  font-size: 18px;
  text-align: center;
  color: #ff7100;
  transform: translateY(5px) !important;
  place-content: flex-end;
}

.v-btn:focus:before {
  background-color: transparent;
}

.looking-btn.selected-looking {
  color: $primary;
  border-color: $primary;
  pointer-events: none;
}

.password-recover {
  text-align: left;
  transform: translateY(-25px);
  color: #000;
}
.login-error {
  position: absolute;
  margin: 0 auto;
  left: 0;
  right: 0;
  transform: translateY(-15px);
}

@media screen and (max-width: 400px) {
  .theme--light.v-sheet {
    width: 100%;
  }
}
</style>
